import React from 'react'
import { useAuth } from '../Context/AuthContext'
import { useHistory } from 'react-router-dom'
import classes from './LogOut.module.css'
function Logout() {
    const { logOut, setLoggedIn } = useAuth();
    const history = useHistory()
    async function handleLogout(params) {
        try {
            await logOut();
            setLoggedIn(false)
            history.push("/login")

        }
        catch {
            console.log("cant logged out");
        }
    }
    return (
        <div>
            <button onClick={handleLogout} className={classes.button}>LogOut</button>
        </div>
    )
}

export default Logout
